import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import api from "@oneleet/api_client";

export async function initSentry(options?: { tunnel?: string }) {
  const metadata = await api.browser.metaGet().then((res) => res.data);

  Sentry.init({
    dsn: "https://700ae7b43d6b4bb09cfeecde2a32f5e8:7f86186068b7413ca7b649943b7001df@o4504991900565504.ingest.sentry.io/4504994429599744",
    environment: metadata.env.SENTRY_ENVIRONMENT,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tunnel: options?.tunnel,
    sendDefaultPii: true,
    tracesSampleRate: 1,
    tracePropagationTargets: [
      /^https:\/\/api\.dev\.oneleet-tools\.com/,
      /^https:\/\/api\.staging\.oneleet-tools\.com/,
      /^https:\/\/api\.oneleet\.com/,
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    integrations: (defaults) => [
      ...defaults,
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    transportOptions: {
      fetchOptions: {
        credentials: "include",
        headers: {
          "Content-Type": "text/plain",
        },
      },
    },
  });

  const client = Sentry.getCurrentScope().getClient();
  if (metadata?.env?.SENTRY_REPLAY_ENABLED && client) {
    client.addIntegration(
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    );
  }

  if (metadata.env.POSTHOG_PUBLIC_PROJECT_ID && client) {
    try {
      const projectId = parseInt(metadata.env.POSTHOG_PUBLIC_PROJECT_ID);
      client.addIntegration(
        posthog.sentryIntegration({
          organization: "Oneleet",
          projectId,
        }),
      );
    } catch (e) {
      console.error("Error initializing posthog", e);
    }
  }
}

export function identifyUser(user: { email: string }) {
  Sentry.setUser(user);
}

export function clearUser() {
  Sentry.setUser(null);
}
